import { useEffect, useState } from "react";
import { useFormConnect, useFormData } from "../../hooks/formHooks";
import { PageData } from "../../models/common_model";
import { DropdownOption, MatchingBatchListItem } from "../../models/testing_model";
import { formatDateTime, parseQueryObject } from "../../utils";
import { Button, Dropdown, DropdownItemProps, Form, Input, Label, Segment, Table } from "semantic-ui-react";
import { restRequest } from "../../http";
import { Page } from "../commons/Page";
import ReactDatePicker from "react-datepicker";
import moment from "moment";

export function MatchingList(props: {}) {
    const [searchData, setSearchField] = useFormData<any>({});
    const [list, setSearchData, isListLoading] = useFormConnect<any, PageData<MatchingBatchListItem>>({}, 'testings/search_matching');

    const [testingResultDropdownOptions, setTestingResultDropdownOptions] = useState<DropdownOption[]>([]);
    const [productOptions, setProductOptions] = useState<DropdownItemProps[]>([]);
    const [stationOptions, setStationOptions] = useState<DropdownItemProps[]>([]);
    const [orderOptions, setOrderOptions] = useState<DropdownItemProps[]>([]);

    useEffect(() => {
        restRequest<DropdownOption[]>('svn_repository/result_dropdown_options').then(setTestingResultDropdownOptions)
    }, []);

    useEffect(() => {
        const options = [{ key: '', text: 'All', value: '' }, ...testingResultDropdownOptions.map(t => ({ key: t.name, text: t.name, value: t.name }))];
        setProductOptions(options);
        if (!options.find(o => o.value == searchData.product)) {
            setSearchField(null, { name: 'product', value: '' });
            setSearchField(null, { name: 'testing_station', value: '' });
            setSearchField(null, { name: 'order', value: '' });
        }
    }, [testingResultDropdownOptions]);

    useEffect(() => {
        const product = testingResultDropdownOptions.find(t => t.name == searchData.product);
        let options: DropdownItemProps[];
        if (product) {
            options = [{ key: '', text: 'All', value: '' }, ...product.children.map(t => ({ key: t.name, text: t.name, value: t.name }))];
        } else {
            options = [{ key: '', text: 'All', value: '' }];
        }

        setOrderOptions(options);

        if (!options.find(o => o.value == searchData.testing_station)) {
            setSearchField(null, { name: 'testing_station', value: '' });
            setSearchField(null, { name: 'order', value: '' });
        }
    }, [testingResultDropdownOptions, searchData.product]);

    useEffect(() => {
        let options: DropdownItemProps[] = [{ key: '', text: 'All', value: '' }];
        const product = testingResultDropdownOptions.find(t => t.name == searchData.product);
        if (product) {
            const station = product.children.find(s => s.name == searchData.order);
            if (station) {
                options = [{ key: '', text: 'All', value: '' }, ...station.children.map(t => ({ key: t.name, text: t.name, value: t.name }))];
            }
        }

        setStationOptions(options);

        if (!options.find(o => o.value == searchData.order)) {
            setSearchField(null, { name: 'testing_station', value: '' });
        }
    }, [testingResultDropdownOptions, searchData.product, searchData.order]);


    return <>
        <Segment.Group>
            <Segment attached="top" loading={isListLoading}>
                <Form onSubmit={e => {
                    setSearchData({ ...searchData, refresh: (searchData.refresh || 0) + 1 });
                }}>
                    <Form.Group>
                        <Form.Input label="Serial:" inline style={{ minWidth: '10rem' }} name="serial_number" value={searchData.serial_number || ''}  onChange={setSearchField}>
                            {/* <Input name="serial_number" value={searchData.serial_number || ''}  onChange={setSearchField}/> */}
                        </Form.Input>

                        <Form.Input inline label="Product:" style={{ minWidth: '10rem' }}>
                            <Dropdown name="product" value={searchData.product || ''} onChange={setSearchField} options={productOptions} search selection fluid></Dropdown>
                        </Form.Input>

                        <Form.Input label="Build:" inline style={{ minWidth: '3rem' }}>
                            <Dropdown name="order" value={searchData.order || ''} onChange={setSearchField} options={orderOptions} search selection fluid></Dropdown>
                        </Form.Input>

                        <Form.Input label="Station:" inline style={{ minWidth: '10rem' }}>
                            <Dropdown name="testing_station" value={searchData.testing_station || ''} onChange={setSearchField} options={stationOptions} search selection fluid></Dropdown>
                        </Form.Input>

                        <div className="inline field" style={{ display: 'flex', alignItems: 'center' }}>
                            <label>Date: &nbsp;&nbsp;</label>
                            <ReactDatePicker showTimeSelect
                                dateFormat="yyyy-MM-d HH:mm"
                                timeFormat="HH:mm"
                                selected={searchData.start_time ? moment(searchData.start_time, 'YYYY-MM-DD HH:mm:ss').toDate() : null} onChange={(ds: Date) => setSearchField(null, { name: 'start_time', value: moment(ds).format('YYYY-MM-DD HH:mm:ss') })}></ReactDatePicker>
                            <div style={{ padding: '0 0.5rem' }}> - </div>
                            <ReactDatePicker showTimeSelect
                                dateFormat="yyyy-MM-d HH:mm"
                                timeFormat="HH:mm"
                                minDate={searchData.start_time ? moment(searchData.start_time, 'YYYY-MM-DD HH:mm:ss').toDate() : null}
                                selected={searchData.end_time ? moment(searchData.end_time, 'YYYY-MM-DD HH:mm:ss').toDate() : null} onChange={(ds: Date) => setSearchField(null, { name: 'end_time', value: moment(ds).format('YYYY-MM-DD HH:mm:ss') })}></ReactDatePicker>
                        </div>

                        <div style={{ paddingLeft: '2rem' }}><Button icon="search" type="submit"></Button></div>
                    </Form.Group>
                </Form>
            </Segment>
            <Segment attached="bottom">
                <Table striped>
                    <Table.Header>
                        <Table.Row>
                            <th>Product</th>
                            <th>Order</th>
                            <th>Testing Station</th>
                            <th>Operator</th>
                            <th>Created At</th>
                            <th></th>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {list?.items.map(obj => {
                            return <tr key={obj.id}>
                                <td>{obj.product}</td>
                                <td>{obj.order}</td>
                                <td>{obj.testing_station}</td>
                                <td>{obj.operator}</td>
                                <td>{formatDateTime(obj.created_at)}</td>
                                <td>
                                    <Button onClick={e => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        if (searchData.serial_number) {
                                            window.open(`/matchings/${obj.id}/${searchData.serial_number}`, '_blank');
                                        } else {
                                            window.open(`/matchings/${obj.id}`, '_blank');
                                        }

                                    }} icon="search" size="mini" />
                                </td>
                            </tr>
                        })}
                    </Table.Body>
                </Table>
                <Page data={list} updatePage={setSearchData}></Page>
            </Segment>
        </Segment.Group>
    </>
}